<template>
    <div class="cashier">
      <van-nav-bar
        title="结算台"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
        :fixed="true"
      />
      <div class="top">
        <p class="money"><span>￥{{$route.query.money}}</span></p>
        
        <!-- <p>订单已提交，请您尽快支付</p> -->
        <!-- <p v-show="this.$route.query.sid">本单超过24小时未结算或未付款将会取消！</p> -->
        <!-- <p >本单超过24小时未结算或未付款将会取消！</p> -->
  
        <!-- <p v-show="!this.$route.query.sid">超级会员费用请联系业务员付款</p>   -->
        <div class="img">
          <van-icon
            name="passed"
            size="1rem"
            color="#a53533"
          />
        </div>
      </div>
      <div class="bottom">
        <div class="title">请选择结算方式</div>
        <ul class="conten">
         <li  @click="mai1" class="clearfix"  >
            <div class="fan">
 
  
            </div>
            <div class="fans"
          
            >
            <img           
              src="../../assets/wechat@2x.png"
              alt=""
            >
            <p>微信支付</p>
            </div>
             
          </li>
           <li @click="mai"  class="clearfix" >
                    <div class="fan">
 
            </div>
            <div  class="fans">
   <img            
              src="../../assets/wweds.png"
              alt=""
            >
            <p>支付宝支付 </p>
            </div>
            
          </li>
      
  
        </ul>
      </div>
      <!-- v-show="uid==7360" -->
        <div    class="but">
          <!-- <van-button
            type="danger"
            size="large"
            @click="go1"
            :disabled='xar'
          >确定提交</van-button> -->
        </div>
      <div
        class="pay"
        v-show="payflag"
      >
        <div
          class="colse"
          @click="colse"
        >
          <van-icon name="cross" />
        </div>
        <img
          :src="img"
          alt=""
        >
      </div>
      <van-dialog v-model="show" title="" @confirm='con'>
    <div class="p">您已成功提交订单，请按选择的结算方式及时付款并提交打款凭证，或及时回复消息，以便我们尽快安排发货（{{n}}s）</div>
  </van-dialog>
   <van-popup
        v-model="show1"
        position="bottom"
        :style="{ height: '40%' }"
      >
        <div class="mi">
          <p>请输入支付密码</p>
          <input
            type="text"
            v-model="value"
          >
          <p>默认支付密码为123456 </p>
          <p>若要修改请去我的页面设置 </p>
  
        </div>
  
        <div class="but">
          <van-button
            type="primary"
            size="large"
            @click="ok"
          >确认</van-button>
        </div>
  
      </van-popup>
    </div>  
  </template>
  <script>
  import Vue from 'vue'
  import { NavBar, Icon,Dialog,Checkbox, CheckboxGroup,Button, Toast,Popup} from 'vant'
  
Vue.use(NavBar).use(Icon).use(Dialog).use(CheckboxGroup).use(Checkbox).use(Button).use(Popup)
import jsBridge from '../../config/jsbridge-mini.js'
  
  export default {
    created () {
      // this.$route.query.sid
      // console.log(this.$route.query.order)
      this.axios.post('pay_type', { store_id: this.$route.query.sid }).then(res => {
        this.list = res.data.data
       this.list.forEach(v => {
          if (v.type == 1) {
            v.type_name = "微信扫码支付"
          } else if (v.type == 2) {
            v.type_name = "支付宝扫码支付"
          } else if (v.type == 3) {
            v.type_name = "线下转账"
          } else if (v.type == 6) {
            v.type_name = "扫码支付"
          } else if (v.type == 5) {
            v.type_name = "信用卡二维码"
          }  
                   this.carr.push({ carrs:false,type:v.type})       
        })
        this.axios.post('cardAndOffline', { store_id: this.$route.query.sid }).then(res => {
          // console.log(res)
          // console.log(this.list)
          if (res.data.data.length > 0) {
            this.list.push({ type_name: '线下转账', type: 3 })
            this.xia = res.data.data
          }
                   this.carr.push({ carrs:false,type:3})       
        }).catch(ref => { })
        this.axios.post('getPreAccount', { store_id: this.$route.query.sid }).then(res => {
          console.log(res)
          // console.log(this.list)
           this.yu=+res.data.data.pre_account_money
          if(this.yu<=0){
            this.checked1=true
          }
        }).catch(ref => { })
      }).catch(ref => { })
   this.axios.post('accountQuota', {}).then(res => {
         this.yu2=+res.data.data.shengyuedu
        
        }).catch(ref => { })
        this.uid=JSON.parse(localStorage.getItem('user')).id
  
        // console.log(this.yu)
    },
    data () {
      return {
        payflag: false,
        list: [],
        img: '',
        xia: [],
        checked:false,
        checked1:false,
        checked2:false,
        checked3:false,
        checked4:false,
        carr:[],
        yu:100,
        yu2:1000,
        show:false,
        show1:false,
        n:6,
        ti:'',
        value:'',
        uid:0,
        xar:true
      }
    },
    methods: {
      onClickLeft () {
        this.$router.push('chuxol')
      },
      payments (v) {
        // console.log(v)
        this.xar=false
  
        if (v.type == 3) {
          this.$router.push({ name: 'transfer', params: { id: this.xia } })
        } else {
          this.img = v.logo
          this.payflag = true
        }
  
      },
      colse () {
        this.payflag = false
      },
      xarr () {
        this.xar=false
  
      },
      fan(v){
        this.xar=false
        if(this.checked){          
          if(this.yu>=this.$route.query.money){
            this.checked4=true
            this.checked3=true
            this.checked2=false
            this.carr.forEach(v=>{
              v.carrs=false
            })
            
          }
  
          
        }else{
            this.checked4=false
            this.checked3=false
  
        }
      },
        fan2(v){
        this.xar=false
  
        if(this.checked2){          
          if(this.yu2>=this.$route.query.money){
            this.checked3=true
            this.carr.forEach(v=>{
              v.carrs=false
            })
            
          }
  
          
        }else{
            this.checked3=false
  
        }
      },
      se(){
  Dialog.confirm({
    title: '',
    message: '确认使用预付余额支付',
  }).then(() => {
      // on confirm
    })
    .catch(() => {
      // on cancel
    });
      },
      go1(){
         if(this.checked2){
          this.show1=true
      }else{
        this.go()
      }
      },
      ok(){
        this.axios.post('usePayPwd', { pwd: this.value, }).then(res => {
         console.log(res)
          Toast(res.data.msg)
          if(res.data.code==200){
            this.show1=false
        this.go()
  
          }
        }).catch(ref => { })
      },
       go(){
      // console.log(this.carr)
      var that=this
     
      let ar=[]
      if(this.checked2){
  ar.push(8)
      }
  if(this.checked){
  ar.push(7)
  }
  
  this.carr.forEach(v=>{
    if(v.carrs){
    ar.push(v.type)
  
    }
  })
  let fg=false
  if(ar.length==1){
    ar.forEach(v=>{
    if(v==7){
      if(this.yu<this.$route.query.money){
        Toast('您的钱包账户余额不足，请同时附加其他结算方式')
        fg=true
      }   
    }
    if(v==8){
  
      if(this.yu2<this.$route.query.money){
  
        Toast('您的鲸信用可用额度不足，请同时附加其他结算方式')
        fg=true
      }
      }
  })
  }
  
    if(ar.indexOf(7)!=-1){
      if(ar.indexOf(8)!=-1){
        if(ar.length>2){
  
        }else{
   if(this.yu2+this.yu<this.$route.query.money){
          console.log(this.yu2+this.yu)
  
        Toast('您的鲸信用可用额度加钱包账户余额不足，请同时附加其他结算方式')
        fg=true
      }
        }
     
    }
    }
      if(fg){
  return
      }
      if(ar.length==0){
        ar=[3]
      }
      if(ar.indexOf(7)==-1){
        this.yu=0
      }
       if(ar.indexOf(8)==-1){
        this.yu2=0
      }
      console.log(ar)
        this.axios.post('changeOrderStatus', { orderId: this.$route.query.order,jiesuan_method:ar,yun_money:this.yu,xin_money:this.yu2  }).then(res => {
         
            console.log(res)       
        this.show=true
      this.ti= setInterval(function(){
      that.n=that.n-1
      console.log(1)
      if(that.n==0){
        clearInterval(that.ti)
        that.$router.push('orderList')
  
      }
      
     },1000)
        }).catch(ref => {
          Toast('提交异常')
        })
    },
    con(){
            this.$router.push('orderList')
  
        },
        mai1(){
 

 // this.$router.push("over")
 this.axios.post('http://106.15.73.87:886/api/wxgetinfo ', {order_id:this.$route.query.order,type:2 }).then(res => {
 console.log(res)
    if(res.data.code!=200){
      Toast(res.data.msg)
      return
    }
 jsBridge.wxPay({
 //微信应用ID
 appid : res.data.info.appid,
 //商户号
 partnerid: res.data.info.partnerid,
 //预支付交易会话ID
 prepayid :res.data.info.prepayid ,
 //扩展字段
 package  :res.data.info.package,
 //随机字符串
 noncestr : res.data.info.noncestr,
 //时间戳（单位是秒，不是毫秒，切记）
 timestamp: res.data.info.timestamp,
 //签名
 sign     : res.data.info.sign 
 }, function (succ, text) {
 let a= JSON.parse(text).errCode
 
 if(a==0){
  location.href='https://nm.huokongjian.net/#/orderList'
 
 }
 
 
 
 });
 }).catch()
 
  
     },
     mai(){
       // location.href='https://www.yimenapp.com/doc/demo48.cshtml'
       // return
   
             this.axios.post('http://106.15.73.87:886/api/aliorderstring', {order_id:this.$route.query.order,type:2 }).then(res => {
                if(res.data.code!=200){
             Toast(res.data.msg)
             return
           }
                 let red= res.data.orderStr
       jsBridge.aliPay({
 orderString:red
 }, function (succ, text) {
   if (succ) {
   location.href='https://nm.huokongjian.net/#/orderList'
   } else {    
     
   }
 })
       }).catch()
   
 
        
     },
   
    },
   
  }
  </script>
  <style lang="less" scoped>
  .cashier {
    background-color: #f5f5f5;
    height: 100%;
  }
  .mi {
    padding: 0.5rem;
    text-align: center;
  
    p {
      font-size: 0.5rem;
      margin: 0.5rem;
    }
    input {
      height: 1rem;
      width: 70%;
      border-radius: 5%;
      font-size: 0.4rem;
    }
    margin-bottom: 1rem;
  }
  .top {
    background-color: #fff;
    padding-top: 1.8rem;
    width: 100%;
    height: 5.5rem;
    text-align: center;
    .img {
      text-align: center;
    }
    p {
      font-size: 0.4rem;
      line-height: 1rem;
      span {
        color: #a52333;
        font-size: 0.45rem;
      }
    }
    .money {
      padding-top: 0.2rem;
      // font-size: 0.5rem;
      span{
        font-size: 0.7rem;
      }
    }
  }
  .bottom {
    background-color: #fff;
    padding: 0.2rem;
    .title {
      font-size: 0.4rem;
      color: #333;
      border-bottom: 1px solid #dfdfdf;
      padding-bottom: 0.15rem;
    }
    .conten {
      
      li {
        height: 1.92rem;
        border-bottom: 1px solid #ccc;
        padding: 0.3rem;
        .fan{
          float: left;
          padding: 0.3rem;
        }
        img {
          width: 1.1rem;
          height: 1.1rem;
          display: block;
          float: left;
          // background-color: #f99;
        }
        p {
          float: left;
          // width: 100%;
          font-size: 0.426667rem;
          line-height: 1.3rem;
          padding-left: 0.5rem;
          span{
            
          }
        }
        .p2{
          line-height: 0.65rem;
          font-size: 0.4rem;
          // padding-right: 0.2rem;
          text-align: right;
          float: right;
        }
      }
    }
  }
  .p{
    padding: 0.5rem;
    font-size: 0.4rem;
  }
  .pay {
    position: fixed;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 10rem;
    // background-color: #f99;
    .colse {
      position: absolute;
      top: 0%;
      font-size: 0.9rem;
      right: 5%;
      color: #ccc;
    }
  }
  .but{
    position: fixed;
    bottom: 0;
    width: 100%;
  }
  </style>
  